import React from "react";
import PropTypes from "prop-types";
import { Card, CardHeader, CardBody, ListGroup, ListGroupItem } from "shards-react";

const TopReferrals = ({ title, referralData, loading }) => (
  <Card small style={{ borderRadius: '0.75rem' }}> {/* Added borderRadius */}
    <CardHeader className="border-bottom">
      <h6 className="m-0">{title}</h6>
      <div className="block-handle" />
    </CardHeader>

    <CardBody className="p-0" style={{ position: 'relative', minHeight: '150px', borderRadius: '0 0 0.75rem 0.75rem', overflow: 'hidden' }}>
      {loading ? (
        <div className="loader-container" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
          <div className="spinner"></div> {/* Loader placeholder */}
        </div>
      ) : (
        <>
          {/* Table Header */}
          <div className="px-3 py-2 d-flex border-bottom" style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}>
            <span className="text-fiord-blue" style={{ flex: 1 }}>Version</span>
            <span className="text-fiord-blue">Percentage</span>
          </div>

          {/* List of version data */}
          <ListGroup small flush className="list-group-small">
            {referralData.map((item, idx) => (
              <React.Fragment key={idx}>
                <ListGroupItem className="d-flex px-3" style={{ border: 'none' }}>
                  <span className="text-fiord-blue" style={{ flex: 1 }}>{item.title}</span>
                  <span className="ml-auto text-right text-reagent-gray">{item.value}</span>
                </ListGroupItem>
                {idx < referralData.length - 1 && <hr className="my-1 mx-3" />}
              </React.Fragment>
            ))}
          </ListGroup>
        </>
      )}
    </CardBody>
  </Card>
);

TopReferrals.propTypes = {
  title: PropTypes.string,
  referralData: PropTypes.array,
  loading: PropTypes.bool,
};

TopReferrals.defaultProps = {
  title: "Version Distribution",
  referralData: [],
  loading: false,
};

export default TopReferrals;
